goog.provide("shadow.js.shim.module$$mui$material$DialogActions$default");
shadow.js.shim.module$$mui$material$DialogActions$default = shadow.js.require(445, {})["default"];
